import React, { Component } from 'react';
import Datas from '../../data/shop/productCategory.json';
import { Link } from 'react-router-dom';
import { Container, Row, Col } from 'react-bootstrap';
import HeaderTwo from '../../components/HeaderTwo';
import FooterTwo from '../../components/FooterTwo';
import { Styles } from './styles/productCategory.js';
import { withTranslation } from 'react-i18next';

class ProductCategory extends Component {
    render() {
        const { t } = this.props;
        return (
            <Styles>
                {/* Main Wrapper */}
                <div className="main-wrapper product-page">

                    {/* Header 2 */}
                    <HeaderTwo />

                    {/* Products */}
                    <section className="product-area">
                        <Container>
                            <Row>
                                <Col md="12">
                                    <nav aria-label="breadcrumb">
                                        <ol className="breadcrumb">
                                            <li className="breadcrumb-item"><Link to={process.env.PUBLIC_URL + "/"}>Home</Link></li>
                                            <li className="breadcrumb-item"><strong>Products</strong></li>
                                        </ol>
                                    </nav>
                                </Col>
                            </Row>
                            <Row>
                                <Col lg="9" md="8" sm="7">
                                    <Row>
                                        {
                                            Datas.map((data, i) => (
                                                <Col lg="4" md="6" key={i}>
                                                    <div className="product-box">
                                                        <div className="product-img">
                                                            <img src={process.env.PUBLIC_URL + `/assets/images/${data.productImg}`} alt="" className="img-fluid" />
                                                            <div className="layer-box"></div>
                                                            <Link className="item_view" to={process.env.PUBLIC_URL + data.productUrl}>{t('shop.view_item')}</Link>
                                                        </div>
                                                        <div className="product-content text-center">
                                                            <div className="pro-title">
                                                                <h5><Link to={process.env.PUBLIC_URL + data.productUrl}>{t(`shop.categories.${data.id}`)}</Link></h5>
                                                            </div>
                                                            <div className="pro-price">
                                                                <p>{data.price}</p>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </Col>
                                            ))
                                        }
                                    </Row>
                                </Col>
                            </Row>
                        </Container>
                    </section>

                    {/* Footer 2 */}
                    <FooterTwo />

                </div>
            </Styles>
        )
    }
}

export default withTranslation()(ProductCategory)